import React from "react";
import useEntity from "../../../hooks/useUserAddress";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./UserAddressListHeader";
import EntityListSearch from "./UserAddressListSearch";
import {useLocation} from "react-router";
import UserAddressListPagination from "./UserAddressListPagination";
import * as Api from "../../../apis/UserAddress.api";
import { UserAddress } from "../../../types/models/UserAddress";
import { PrimaryUserAddress } from "../../../types/models/UserAddress";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import UserLink from "../../../../auth/components/user/UserDetail/UserLink";
import UserName from "../../../../auth/components/user/UserDetail/UserName";
import AddressLink from "../../../../address/components/address/AddressDetail/AddressLink";
import AddressName from "../../../../address/components/address/AddressDetail/AddressName";

import { PrimaryUser } from "../../../../auth/types/models/User";
import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import UserAddressListItemTools from "./UserAddressListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    userId?: ID,
    addressId?: ID,
    };

const UserAddressListItem = (props: IProps) => {
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('UserAddress')

    
    
    
    
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          
            Api.useGetUserAddressListQuery({ 
                  page, pageSize 
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: UserAddress) => routeLocation.pathname.endsWith('user-addresses') ?
        `${PrimaryUserAddress.fromEntity(entity).toPath()}`
        :
        `user-addresses/${PrimaryUserAddress.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: UserAddress) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                
                <TableContainer>

                    


                    

                    

                    

                    
        
                    
                        <Table stickyHeader data-testid="UserAddress-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    { query.userId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'userId') }
                                                direction={ orderBys.find((item) => item.name === 'userId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('userId')}
                                            >
                                            
                                                <Trans>User</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    { query.addressId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'addressId') }
                                                direction={ orderBys.find((item) => item.name === 'addressId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('addressId')}
                                            >
                                            
                                                <Trans>Address</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryUserAddress.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        { query.userId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <UserLink id={ item.userId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        { query.addressId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <AddressLink id={ item.addressId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <UserAddressListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No User Addresses</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <UserAddressListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default UserAddressListItem;
